var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.room &&
    _vm.featuresField &&
    _vm.room[_vm.featuresField] &&
    Object.keys(_vm.room[_vm.featuresField]).length > 0
  )?_c('v-row',{staticClass:"object-features",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pt-3 pb-1",attrs:{"cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.room.number))])]),_vm._l((_vm.filteredAndSortedFeatureIds),function(featureId){return [_c('v-col',{key:featureId + '_quantity',staticClass:"text-right pr-1",attrs:{"cols":"1"}},[(
          _vm.room[_vm.featuresField][featureId].quantity &&
          !_vm.showQtyIcons.includes(_vm.featuresList[featureId].icon)
        )?[_vm._v("\n        "+_vm._s(_vm.room[_vm.featuresField][featureId].quantity)+" x\n      ")]:_vm._e()],2),_c('v-col',{key:featureId + '_name',attrs:{"cols":"11"}},[(
          _vm.showQtyIcons.includes(_vm.featuresList[featureId].icon) &&
          _vm.room[_vm.featuresField][featureId].quantity
        )?[_vm._l((Array(
            parseInt(_vm.room[_vm.featuresField][featureId].quantity)
          )),function(icon_i,i2){return _c('v-icon',{key:icon_i,class:i2 < parseInt(_vm.room[_vm.featuresField][featureId].quantity) - 1 ||
            parseInt(_vm.room[_vm.featuresField][featureId].quantity) > 1
              ? 'mr-2'
              : ''},[_vm._v("\n          "+_vm._s(_vm.featuresList[featureId].icon)+"\n        ")])}),_vm._v("\n        "+_vm._s(parseInt(_vm.room[_vm.featuresField][featureId].quantity) > 1
            ? _vm.room[_vm.featuresField][featureId].quantity
            : '')+"\n      ")]:_c('v-icon',[_vm._v("\n        "+_vm._s(_vm.featuresList[featureId].icon)+"\n      ")]),_vm._v("\n      "+_vm._s(_vm.featureName(featureId))+"\n    ")],2)]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }